// src/pages/razorPay/razorpay.js
import { Navigate } from "react-router-dom";
import {
  payementCreate,
  getOrderDetails,
} from "../../services/api/orderService";

// Load Razorpay script dynamically
export const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    if (typeof window.Razorpay === "function") {
      resolve(true);
      return;
    }

    delete window.Razorpay;
    const existingScript = document.querySelector(
      'script[src="https://checkout.razorpay.com/v1/checkout.js"]',
    );
    if (existingScript) existingScript.remove();

    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => {
      console.log("Razorpay script loaded successfully");
      resolve(true);
    };
    script.onerror = () => {
      console.error("Failed to load Razorpay script");
      resolve(false);
    };
    document.body.appendChild(script);
  });
};

// Record payment result in your backend
export const recordPayment = async ({
  orderNumber,
  amount,
  response,
  isSuccess,
  errorDetails,
}) => {
  console.log("Recording payment with data:", {
    orderNumber,
    amount,
    response,
    isSuccess,
    errorDetails,
  });
  
  try {
    const paymentData = {
      order_number: orderNumber,
      payment_method: "Razorpay",
      amount: amount / 100,
      reference_number: isSuccess ? response?.razorpay_payment_id : null,
      notes: JSON.stringify({
        razorpay_payment_id: response?.razorpay_payment_id,
        razorpay_order_id: response?.razorpay_order_id,
        razorpay_signature: response?.razorpay_signature,
        error_details: errorDetails,
      }),
      is_success: isSuccess,
    };

    console.log("Calling payementCreate with data:", paymentData);
    const result = await payementCreate(paymentData);
    console.log("payementCreate response:", result);
    console.log("payementCreate response:", result.data);
    
    if (result.data?.success === true) {
      // Store order details in localStorage to show popup on home page
      console.log("Storing order details for popup, order:", orderNumber);
      const orderDetails = {
        orderNumber: orderNumber,
        showPopup: true,
        timestamp: Date.now()
      };
      localStorage.setItem("showOrderSuccessPopup", JSON.stringify(orderDetails));
      
      // Redirect to home page instead of order-success
      console.log("Redirecting to home page to show order success popup");
      window.location.href = "/";
    }
    return result;
  } catch (error) {
    console.error("Failed to record payment:", error);
    console.error("Error details:", error.response?.data || error.message);
    throw error;
  }
};